import type { SeptFlash48MarketTier } from '../utils/get-sept-flash-48-variant';
import { getSeptFlash48MarketTier } from '../utils/get-sept-flash-48-variant';

export type SeptFlash48Variant = 'g1' | 'g2';

export const SEPT_FLASH_48_CTA_LABEL = 'Save Now';

export const SEPT_FLASH_48_CHECKOUT_HREF: Record<SeptFlash48MarketTier, string> = {
  full: '/checkout/individual/4month/credit-card',
  low: '/checkout/individual/annually/credit-card',
};

type SeptFlash48VariantConfig = {
  backgroundGradient: string;
  borderColor: string;
  eyebrowColor: string;
  patternOpacity: number;
  subtitleColor: string;
  headline: string;
  catalogHeadline: string;
  subtitle: string;
  homepagePatternDesktop: string;
  homepagePatternMobile: string;
  homepageStampDesktop: string;
  homepageStampMobile: string;
  homepageStampSizeDesktop: { height: number; width: number };
  homepageStampSizeMobile: { height: number; width: number };
  experiencePattern: string;
  experienceStampDesktop: string;
  experienceStampMobile: string;
  catalogPatternDesktop: string;
  catalogPatternMobile: string;
};

export const SEPT_FLASH_48_VARIANTS: Record<SeptFlash48Variant, SeptFlash48VariantConfig> = {
  g1: {
    backgroundGradient: 'linear-gradient(109deg, #00040E 0%, #00298C 100%)',
    borderColor: '#175CFF',
    eyebrowColor: '#AFC6FF',
    patternOpacity: 0.2,
    subtitleColor: '#D2DFFF',
    headline: 'Just 48 hours to save',
    catalogHeadline: '48% off, for 48 hours',
    subtitle: 'All AI engineering, data & product courses',
    homepagePatternDesktop: '/images/promotions/sept-flash-48/background-pattern.webp',
    homepagePatternMobile: '/images/promotions/sept-flash-48/background-pattern.webp',
    homepageStampDesktop: '/images/promotions/sept-flash-48/48-percent-off-desktop.webp',
    homepageStampMobile: '/images/promotions/sept-flash-48/48-percent-off-mobile.webp',
    homepageStampSizeDesktop: { height: 140, width: 355 },
    homepageStampSizeMobile: { height: 84, width: 294 },
    experiencePattern: '/images/promotions/sept-flash-48/background-pattern.webp',
    experienceStampDesktop: '/images/promotions/sept-flash-48/48-percent-off-desktop.webp',
    experienceStampMobile: '/images/promotions/sept-flash-48/48-percent-off-mobile.webp',
    catalogPatternDesktop: '/images/promotions/sept-flash-48/background-pattern.webp',
    catalogPatternMobile: '/images/promotions/sept-flash-48/background-pattern.webp',
  },
  g2: {
    backgroundGradient: 'linear-gradient(73deg, #08000E 0%, #6100B0 100%)',
    borderColor: '#931CF5',
    eyebrowColor: '#EBBAFF',
    patternOpacity: 0.2,
    subtitleColor: '#F6DFFF',
    headline: '48 hour flash sale',
    catalogHeadline: '48 hour flash sale',
    subtitle: 'On all the latest AI & tech courses',
    homepagePatternDesktop: '/images/promotions/sept-flash-48/background-pattern.webp',
    homepagePatternMobile: '/images/promotions/sept-flash-48/background-pattern.webp',
    homepageStampDesktop: '/images/promotions/sept-flash-48/48-hours-desktop.webp',
    homepageStampMobile: '/images/promotions/sept-flash-48/48-hours-mobile.webp',
    homepageStampSizeDesktop: { height: 129, width: 383 },
    homepageStampSizeMobile: { height: 88, width: 294 },
    experiencePattern: '/images/promotions/sept-flash-48/background-pattern.webp',
    experienceStampDesktop: '/images/promotions/sept-flash-48/48-hours-desktop.webp',
    experienceStampMobile: '/images/promotions/sept-flash-48/48-hours-mobile.webp',
    catalogPatternDesktop: '/images/promotions/sept-flash-48/background-pattern.webp',
    catalogPatternMobile: '/images/promotions/sept-flash-48/background-pattern.webp',
  },
};

export function getSeptFlash48CheckoutHref(variant: SeptFlash48Variant, promoCode?: string | null): string {
  const href = SEPT_FLASH_48_CHECKOUT_HREF[getSeptFlash48MarketTier(variant)];
  if (!promoCode) {
    return href;
  }
  const separator = href.includes('?') ? '&' : '?';
  return `${href}${separator}coupon=${encodeURIComponent(promoCode)}`;
}
